// Size Chart Modal Controller
(function () {
  function initSizeChart() {
    const dialogComponent = document.querySelector('dialog-component.size-chart-dialog-component');
    if (!dialogComponent) return;

    const dialog = dialogComponent.querySelector('dialog');
    if (!dialog) return;

    // Open Size Chart Dialog
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-chart-trigger], a[href="#size-chart"]');
      if (!trigger) return;

      event.preventDefault();
      if (typeof dialogComponent.showDialog === 'function') {
        dialogComponent.showDialog();
      } else if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });

    // Tab Switching (Regular vs Oversized)
    dialogComponent.addEventListener('click', (event) => {
      const tabButton = event.target.closest('[data-size-tab]');
      if (!tabButton) return;

      const targetFit = tabButton.getAttribute('data-size-tab');
      if (!targetFit) return;

      // Update Tab Buttons
      dialogComponent.querySelectorAll('[data-size-tab]').forEach((btn) => {
        const isActive = btn.getAttribute('data-size-tab') === targetFit;
        btn.classList.toggle('size-chart-tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update Tab Panels
      dialogComponent.querySelectorAll('[data-size-panel]').forEach((panel) => {
        const isActive = panel.getAttribute('data-size-panel') === targetFit;
        panel.classList.toggle('size-chart-panel--active', isActive);
        panel.hidden = !isActive;
      });
    });

    // Unit Switching (Inches vs CM)
    dialogComponent.addEventListener('click', (event) => {
      const unitButton = event.target.closest('[data-unit-btn]');
      if (!unitButton) return;

      const targetUnit = unitButton.getAttribute('data-unit-btn');
      if (!targetUnit) return;

      // Update Unit Buttons
      dialogComponent.querySelectorAll('[data-unit-btn]').forEach((btn) => {
        const isActive = btn.getAttribute('data-unit-btn') === targetUnit;
        btn.classList.toggle('size-chart-unit-btn--active', isActive);
      });

      // Update Value Displays
      dialogComponent.querySelectorAll('[data-val-in]').forEach((cell) => {
        if (targetUnit === 'cm') {
          cell.textContent = cell.getAttribute('data-val-cm') || cell.textContent;
        } else {
          cell.textContent = cell.getAttribute('data-val-in') || cell.textContent;
        }
      });

      // Update unit label
      dialogComponent.querySelectorAll('.size-chart-unit-indicator').forEach((indicator) => {
        indicator.textContent = targetUnit === 'cm' ? 'CM' : 'INCHES';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChart);
  } else {
    initSizeChart();
  }

  // Handle Shopify theme editor re-renders
  document.addEventListener('shopify:section:load', initSizeChart);
})();
